import * as yup from "yup"; // Schema validation

// TODO use const to define regexes here that get reused

// Here is the schema definition
let schema = yup.object().shape({
  /* Insurance Agent Types */
  AgencyName: yup
    .string()
    .matches(/^[a-zA-Z '-]*$/)
    .required(),
  Status: yup
    .string()
    .matches(/^[a-zA-Z '-]*$/),
  IsFarmersAgent: yup
    .boolean(),
  IsNationwideAgent: yup
    .boolean(),
  IsGreenPathAgent: yup
    .boolean(),
  IsNextWaveAgent: yup
    .boolean(),
  IsSmartChoiceAgent: yup
    .boolean(),
  IsAaaAcgAgent: yup
    .boolean(),
  IsAlliedAgent: yup
    .boolean(),
  IsAllegianceAgent: yup
    .boolean(),
  IsPiibAgent: yup
    .boolean(),
  IsUnitedValleyAgent: yup
    .boolean(),
  IsPiaAgent: yup
    .boolean(),
  IsSecureRiskAgent: yup
    .boolean(),
  IsCombinedAgentsofAmericaAgent: yup
    .boolean(),
  IsRenaissanceAllianceAgent: yup
    .boolean(),
  IsInsProfessionalAgency: yup
    .boolean(),
  IsInsurorsGroupAgent: yup
    .boolean(),
  IsGeorgiaAgencyPartnersAgent: yup
    .boolean(),
  IsUnitedAgenciesAgent: yup
    .boolean(),
  IsIsuAgent: yup
    .boolean(),
  IsPacwestAllianceAgent: yup
    .boolean(),
  IsRockyMountainWestAgent: yup
    .boolean(),
  IsIroquoisAgent: yup
    .boolean(),
  IsPacificCrestAgent: yup
    .boolean(),
  IsOliInsuranceAgent: yup
    .boolean(),
  SeparateAddress: yup
    .boolean()
    .required()
    .default(false),
  Address: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  City: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  // public int StateID{ get; set; }
  State: yup
    .string()
    .matches(/^[a-zA-Z ]*$/, "State is not valid") // TODO make sure length is 2
    .required(),
  Zip: yup
    .string()
    .matches(/^[0-9]*/, "Zip is not valid") // TODO make sure length is 5
    .required(),

  MailingAddress: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  MailingCity: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  //public int MailingStateID{ get; set; }
  MailingState: yup
    .string()
    .matches(/^[a-zA-Z ]*$/, "State is not valid") // TODO make sure length is 2
    .required(),
  MailingZip: yup
    .string()
    .matches(/^[0-9]*/, "Zip is not valid") // TODO make sure length is 5
    .required(),

  PrincipalName: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  PrincipalEmail: yup
    .string()
    .email()
    .required(),
  ContactName: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  ContactEmail: yup
    .string()
    .email()
    .required(),
  IsSpanishSpeaking: yup
    .boolean()
    .default(false),
  PhoneNumber: yup
    .string()
    .required(),
  FaxNumber: yup
    .string()
    .required(),
  MobileNumber: yup
    .string()
    .required(),
  Violation: yup
    .string()
    .required(),
  ViolationExplanation: yup
    .string(),
  EandOClaimsInPastFive: yup
    .boolean(),
  EandOClaimsInPastFiveExplanation: yup
    .string(),

  BankruptcyInPastFive: yup
    .boolean(),
  BankruptcyInPastFiveExplanation: yup
    .string(),

  OpenLiens: yup
    .boolean(),
  OpenLiensExplanation: yup
    .string(),

  NumberofRisksPlacedYearly: yup
    .string(),
  HowDidYouHearAboutUs: yup
    .string(),
  HearAboutUsOther: yup
    .string(),
  PromoCode: yup
    .string(),
  LicenseNo: yup
    .string()
    .matches(/^[a-zA-Z0-9]*$/),
  EOPNumber: yup
    .string()
    .matches(/^[a-zA-Z0-9]*$/)
    .required(),
  EOPCarrierName: yup
    .string()
    .required(),
  EOPExpDate: yup
    .string()
    .required(),
  EOPLimit: yup
    .string()
    .matches(/^[0-9]*$/)
    .required(),
  BusinessType: yup
    .string()
    .matches(/^[a-zA-Z ]*$/)
    .required(),
  AgencyType: yup
    .number()
    .default(1),
  StatementEmail: yup
    .string(),
  TaxID: yup
    .string()
    .required(),
  TaxIDName: yup
    .string()
    .required(),
})

export { schema };